import Color from "./Color";
import DateTime from "./DateTime";
import DateTimePicker from "./DateTimePicker";
import DateGroup from "./DateGroup";
import Dropdown from "./Dropdown";
import DropdownSearch from "./DropdownSearch";
import InputAutoSuggestion from "./InputAutoSuggestion";
import InputBilingual from "./InputBilingual";
import InputCheckBox from "./InputCheckBox";
import InputCustomerAutoSuggestion from "./InputCustomerAutoSuggestion";
import InputDatePickerBetween from "./InputDatePickerBetween";
import InputFilter from "./InputFilter";
import InputMultiSelect from "./InputMultiSelect";
import InputMutiCheckbox from "./InputMutiCheckbox";
import InputSwitch from "./InputSwitch";
import InputSwitchAlertApi from "./InputSwitchAlertApi";
import InputWysiwyg from "./InputWysiwyg";
import TextArea from "./TextArea";
import TextField from "./TextField";
import Radio from "./Radio";
import Upload from "./Upload";
import UploadImage from "./UploadImage";
import UploadImageQuestion from "./UploadImageQuestion";
import UploadSetImage from "./UploadSetImage";
import UploadImageInput from "./UploadImageInput";

const EXPORT = {
  Color,
  DateGroup,
  DateTime,
  DateTimePicker,
  Dropdown,
  DropdownSearch,
  InputAutoSuggestion,
  InputBilingual,
  InputCheckBox,
  InputCustomerAutoSuggestion,
  InputDatePickerBetween,
  InputFilter,
  InputMutiCheckbox,
  InputMultiSelect,
  TextField,
  InputSwitch,
  InputSwitchAlertApi,
  InputWysiwyg,
  TextArea,
  Radio,
  Upload,
  UploadImage,
  UploadImageInput,
  UploadImageQuestion,
  UploadSetImage,
};

export default EXPORT;
